
import Vue from 'vue';
import {
	RunnitNodeDefTagType,
	READABLE_RUNNIT_NODE_DEF_TAG_TYPE,
	RUNNIT_NODE_DEF_TAG_TYPE,
	RUNNIT_NODE_DEF_TAG_TYPE_ICON,
} from '@run-diffusion/shared';
import { RUNNITS_OWNER_SELECTION } from './constants';
import { mapState } from 'vuex';
import RunnitCarousel from './RunnitCarousel.vue';
import _truncate from 'lodash/truncate';

export default Vue.extend({
	name: 'RunnitTagTypeTabs',
	props: {
		value: { type: String, default: null },
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TAG_TYPE,
		};
	},
	computed: {
		...mapState([
			'runnitState',
			'team',
			'user',
		]),
		includeTeamTab () {
			return !!(
				this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM &&
				this.team
			);
		},
		items () {
			const result = [{
				id: 0,
				label: 'All',
				icon: 'mdi-apps',
				tagType: 'ALL',
			}];
			if (this.includeTeamTab) {
				result.push({
					id: 1,
					label: _truncate(this.team?.company?.name || 'Company', { length: 20 }),
					icon: 'mdi-account-multiple-outline',
					tagType: 'COMPANY',
				});
			}

			Object.values(RUNNIT_NODE_DEF_TAG_TYPE)
				.filter((tagType: RunnitNodeDefTagType) => {
					const excludedTypes: RunnitNodeDefTagType[] = [
						RUNNIT_NODE_DEF_TAG_TYPE.HOME_PAGE,
						RUNNIT_NODE_DEF_TAG_TYPE.INDUSTRY,
						RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE,
						RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_QUALITY,
						RUNNIT_NODE_DEF_TAG_TYPE.INTERNAL,
					];
					return this.user.isAdmin || !excludedTypes.includes(tagType);
				})
				.forEach((t: RunnitNodeDefTagType) => {
					result.push({
						id: result.length,
						label: READABLE_RUNNIT_NODE_DEF_TAG_TYPE[t],
						tagType: t,
						icon: RUNNIT_NODE_DEF_TAG_TYPE_ICON[t]
					});
			});
			return result;
		},
	},
	methods: {
		handleTabChange (category) {
			this.$emit('on-select', category)
		}
	},
	components: {
		RunnitCarousel
	},
});
